<template>
    <button :name="name" type="submit" :id="_id" :required="_required" :class="sizeClass">
        <slot></slot>
    </button>
</template>
<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator';
    import FormRow from './FormRow.vue';

    @Component({
        name: 'FormInputSubmit',
    })
    export default class FormInputSubmit extends Vue
    {
        @Prop({
            type: String,
        }) id: string;

        @Prop({
            type: String,
        }) name: string;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) required: boolean;

        @Prop({
            type: String,
            default: 'none',
            required: false,
            validator: function(value)
            {
                return ['none', 'long', 'medium', 'small'].includes(value);
            },
        }) size: string;

        get _id()
        {
            return this.id || this.formRow?.labelFor || null;
        }

        get _required()
        {
            return this.required && this.required || this.formRow?.required || false;
        }

        get formRow()
        {
            let formRow = this.$parent as FormRow;

            return formRow?.$options.name === 'FormRow' ? formRow : null;
        }

        get sizeClass()
        {
            return 'none' !== this.size && this.size || '';
        }
    };
</script>